import { send } from 'server';

export const acceptCoolingOff = accept => send({
    ID: 89903,
    responses: [89907, 89900],
    description: 'Pending Deposit Limit Accept',
    action: accept ? 'accept' : 'decline'
});
